import LegalLayout from "@/components/LegalLayout";

export default function Refund() {
  return (
    <LegalLayout
      eyebrow="Doctrine 03"
      title="Refund & Cancellation"
      updated="February 2026"
      testid="page-refund"
    >
      <section>
        <p className="text-white/60 italic">
          The Club is built on scarcity. Once access is granted, capacity is committed. This policy explains
          when a refund is possible and when it is not.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">1. Memberships</h2>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li>Inner Circle membership renews automatically at <strong>$10 USD / month</strong>.</li>
          <li>You may cancel at any time from your member dashboard. Cancellation stops future billing immediately.</li>
          <li>The current billing period remains active until its end date — you retain member benefits until then.</li>
          <li><strong className="text-cyan-400">No partial or pro-rated refunds</strong> are issued for the unused portion of a paid month.</li>
          <li>If you were charged in error (e.g. duplicate charge, failed cancellation on our side), email us within 30 days and we will refund in full.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">2. Event Tickets</h2>
        <p>
          Because our events are capacity-locked and every ticket sold removes a seat from another guest,
          tickets are <strong className="text-cyan-400">non-refundable and non-transferable</strong> once
          purchased, except in the following cases:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li><strong>Event cancelled by the Club</strong> — full refund to original payment method within 10 business days.</li>
          <li><strong>Event postponed by more than 30 days</strong> — you may request a full refund within 7 days of the postponement announcement.</li>
          <li><strong>Duplicate charge or technical error</strong> — full refund upon verification.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">3. Denied Entry</h2>
        <p>
          Tickets are void and non-refundable if entry is refused for any of the following reasons:
        </p>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li>Failure to present valid government-issued photo ID matching the guest list name.</li>
          <li>Attempting to enter under a false identity.</li>
          <li>Arriving in a state of intoxication or under the influence of illegal substances.</li>
          <li>Violating the dress code, code of conduct, or venue policies.</li>
          <li>Arriving after final entry cutoff (typically 90 minutes after door open).</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">4. Merch (Identity Vault)</h2>
        <ul className="list-disc pl-6 space-y-2 text-white/70">
          <li>Merch items are limited drops. Sales are <strong>final</strong> once shipped.</li>
          <li>If an item arrives damaged or defective, contact us within 7 days of delivery with photos. We will replace or refund at our discretion.</li>
          <li>Complimentary influencer-tier items are not refundable or exchangeable for cash.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">5. How To Request A Refund</h2>
        <ol className="list-decimal pl-6 space-y-2 text-white/70">
          <li>Email <a href="mailto:secretsoulciety@secretsoulcietyclub.com" className="text-cyan-400 hover:text-white transition">secretsoulciety@secretsoulcietyclub.com</a> with the subject line <em>"Refund Request — [Order ID]"</em>.</li>
          <li>Include your full name, order or ticket ID, event name, and the reason for the request.</li>
          <li>Approved refunds are processed within 10 business days to the original payment method. Depending on your bank, it may take an additional 3–7 days to appear on your statement.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wide">6. Chargebacks</h2>
        <p>
          Filing a chargeback without first contacting us may result in a permanent ban from the Club and
          all future events. If you believe a charge is unauthorized or incorrect, email us first — we
          resolve legitimate disputes quickly and quietly.
        </p>
      </section>
    </LegalLayout>
  );
}
